module.exports = __webpack_public_path__ + "static/img/chinaRadio.eab4741.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/chinaRadio.png
// module id = SnLE
// module chunks = 1